module.exports = __webpack_public_path__ + "img/18_67.09722b45.png";